import type { ISO2 } from '@/constants/countries/ISO2';

import { DropdownEmptyState } from '../DropdownEmptyState';

import { getSanitisedUrl } from '../../utils';
import { BrokerageLogo } from './BrokerageLogo';
import { ComboBox, Item } from './components/ComboBox';

type Option = {
  url: string | null;
  countryISO: ISO2 | null;
  id: string;
  label: string;
  name: string;
};

interface Props {
  options: Option[];
  disabled: boolean;
  onSelect?: (id: string) => void;
  onFocus?: () => void;
  inputValue?: string;
  onInputChange?: (value: string) => void;
  status: 'pending' | 'success' | 'error';
}

export const BrokerageComboBox = ({
  options,
  disabled,
  onSelect,
  onFocus,
  inputValue,
  onInputChange,
  status,
}: Props) => {
  return (
    <ComboBox
      label="Select a broker"
      placeholder="Search 2,000+ brokers worldwide"
      isDisabled={disabled}
      emptyStateRender={(props) => <DropdownEmptyState {...props} />}
      items={options}
      inputValue={inputValue}
      onSelectionChange={(id) => onSelect?.(String(id))}
      onInputChange={onInputChange}
      onFocus={onFocus}
      status={status}
    >
      {(item) => (
        <Item textValue={item.label} key={item.id}>
          <div className="ml-2">
            <div className="grid grid-cols-[40px_1fr] grid-rows-[40px] items-center gap-2">
              <BrokerageLogo name={item.name} url={getSanitisedUrl(item.url)} />
              <div className="max-w-[300px]">
                <p className="m-0 truncate text-xs">{item.label}</p>
                {item.url !== null ? (
                  <p className="m-0 text-tiny opacity-50">
                    {getSanitisedUrl(item.url)}
                  </p>
                ) : null}
              </div>
            </div>
          </div>
        </Item>
      )}
    </ComboBox>
  );
};
